import { remoteJSON } from './remote';

/**
 *
 * set limit to null to cancel a limit
 *
 */
export const setAccountLimits = async (typeId: number, durationId: number, limit: number | null) => {
	const response = (await remoteJSON('/limits', {
		method: 'POST',
		body: JSON.stringify({
			limit_type_id: typeId,
			duration_type_id: durationId,
			limit,
		}),
	})) as SetAccountLimitsResponse;

	return response;
};
